"use strict";
const getClosestScrollable = (element) => {
  let parent = element.parentElement;
  while (parent) {
    const style = window.getComputedStyle(parent);
    const isScrollable = ["scroll", "auto"].includes(style.overflowY);
    if (isScrollable) {
      return parent;
    }
    const isPositionFixed = style.position === "fixed";
    if (isPositionFixed) {
      return null;
    }
    parent = parent.parentElement;
  }
  return null;
};
export const scrollAwayObserver = (element, { onScrollAway }) => {
  const closestScrollable = getClosestScrollable(element);
  if (!closestScrollable)
    return void 0;
  const intersectionObserver = new IntersectionObserver(
    (entries) => {
      if (!entries[0].isIntersecting) {
        onScrollAway();
      }
    },
    {
      root: closestScrollable,
      threshold: 0
    }
  );
  intersectionObserver.observe(element);
  return () => {
    intersectionObserver.disconnect();
  };
};
